const SECTIONS = [
  ['Identifiers', [
    ['call_id', 'string', 'call_abc123def456'],
    ['call_sid', 'string', 'CA1234567890abcdef'],
    ['agent_id', 'string', 'agent_9f2c1b'],
    ['agent_name', 'string', 'Chloe'],
    ['sub_account_id', 'string', 'sub_123'],
  ]],
  ['Contact', [
    ['contact_id', 'string', 'ghl_contact_789'],
    ['contact_info.name', 'string', 'John Doe'],
    ['contact_info.first_name', 'string', 'John'],
    ['contact_info.last_name', 'string', 'Doe'],
    ['contact_info.phone', 'string', '+12125551234'],
    ['contact_info.email', 'string', 'john@example.com'],
  ]],
  ['Call', [
    ['direction', 'string', 'outbound'],
    ['from_number', 'string', '+18005550100'],
    ['to_number', 'string', '+12125551234'],
    ['status', 'string', 'completed'],
    ['answered', 'boolean', 'true'],
    ['amd_status', 'string', 'human'],
    ['end_reason', 'string', 'caller_hung_up | agent_ended | transferred | voicemail | no_answer'],
    ['duration_seconds', 'number', '185'],
    ['call_start_time', 'string', '12-21-2021 08:30 AM'],
    ['call_start_time_utc', 'string (ISO)', '2021-12-21T13:30:00+00:00'],
    ['call_end_time', 'string', '12-21-2021 08:33 AM'],
    ['call_end_time_utc', 'string (ISO)', '2021-12-21T13:33:05+00:00'],
    ['timezone', 'string', 'America/New_York'],
  ]],
  ['AI Analysis', [
    ['outcome', 'string', 'appointment_booked'],
    ['call_summary', 'string', 'John asked about pricing…'],
    ['call_analysis.sentiment', 'string', 'positive | neutral | negative'],
    ['call_analysis.lead_interest_score', 'number (0-10)', '8'],
    ['call_analysis.el_data_collected', 'object', '{ "budget": "…" }'],
  ]],
  ['Callback / Textback', [
    ['callback.requested', 'boolean', 'true'],
    ['callback.scheduled_for', 'string', '12-22-2021 08:30 AM'],
    ['callback.scheduled_for_utc', 'string (ISO)', '2021-12-22T13:30:00+00:00'],
    ['callback.timezone', 'string', 'America/New_York'],
    ['callback.caller_request', 'string', 'Can you call me back tomorrow at same time'],
    ['callback.reason', 'string', 'Wants to talk to partner first'],
    ['callback.status', 'string', 'scheduled'],
    ['callback.scheduled_id', 'string', 'cb_1a2b3c'],
    ['textback.*', 'object', 'Same fields as callback'],
  ]],
  ['Appointment', [
    ['appointment.booked', 'boolean', 'true'],
    ['appointment.appointment_id', 'string', 'appt_456'],
    ['appointment.start_time', 'string', '12-24-2021 02:00 PM'],
    ['appointment.start_time_utc', 'string (ISO)', '2021-12-24T19:00:00+00:00'],
    ['appointment.end_time', 'string', '12-24-2021 02:30 PM'],
    ['appointment.end_time_utc', 'string (ISO)', '2021-12-24T19:30:00+00:00'],
    ['appointment.timezone', 'string', 'America/New_York'],
    ['appointment.calendar_id', 'string', 'cal_789'],
    ['appointment.calendar_name', 'string', 'Demo Calls'],
    ['appointment.appointment_time', 'string', 'Friday, December 24 at 2:00 PM EST'],
  ]],
  ['Transfer', [
    ['transfer.transferred', 'boolean', 'false'],
    ['transfer.transferred_to', 'string', '+13055550199'],
    ['transfer.destination_name', 'string', 'Sales Team'],
  ]],
  ['Transcript & Actions', [
    ['transcript', 'string', 'Agent: Hi John…\\nCustomer: Hey…'],
    ['transcript_entries', 'array', '[{ role, text, timestamp }]'],
    ['audio_url', 'string', 'https://api.twilio.com/…/RE123.mp3'],
    ['function_calls', 'array', '[{ function, result, details }]'],
    ['tags_added', 'array', '["demo-scheduled"]'],
    ['sms_activity', 'object', '{ … }'],
    ['timestamp', 'string (ISO)', '2021-12-21T13:33:10+00:00'],
    ['source', 'string', 'voxinity_ai'],
  ]],
];

export const PostCallPayloadTable = ({ textPrimary, textSecondary, inputBg, cardBorder }) => (
  <div className={`mt-2 rounded-lg ${inputBg} border ${cardBorder} overflow-x-auto`} data-testid="post-call-payload-table">
    <table className="w-full text-left text-[11px] min-w-[520px]">
      <thead>
        <tr className={`border-b ${cardBorder} ${textSecondary} uppercase tracking-wider text-[10px]`}>
          <th className="px-3 py-2 font-semibold">Field</th>
          <th className="px-3 py-2 font-semibold">Type</th>
          <th className="px-3 py-2 font-semibold">Example</th>
        </tr>
      </thead>
      {SECTIONS.map(([title, rows]) => (
        <tbody key={title} data-testid={`payload-section-${title.toLowerCase().replace(/[^a-z]+/g, '-')}`}>
          <tr>
            <td colSpan={3} className="px-3 pt-3 pb-1 text-[10px] font-semibold uppercase tracking-wider text-teal-500">{title}</td>
          </tr>
          {rows.map(([field, type, example]) => (
            <tr key={field} className={`border-t ${cardBorder}`} data-testid={`payload-row-${field.replace(/[^a-z_]+/gi, '-')}`}>
              <td className={`px-3 py-1.5 font-mono whitespace-nowrap ${textPrimary}`}>{field}</td>
              <td className={`px-3 py-1.5 whitespace-nowrap ${textSecondary}`}>{type}</td>
              <td className={`px-3 py-1.5 font-mono break-words ${textSecondary}`}>{example}</td>
            </tr>
          ))}
        </tbody>
      ))}
    </table>
  </div>
);
